export function uuidv4(): string {
	return crypto.randomUUID();
}

export function validateUUID(uuid: string): boolean {
	return /^[a-f0-9]{8}-([a-f0-9]{4}-){3}[a-f0-9]{12}$/i.test(uuid);
}
